import React from 'react';
import moLogo from '../assets/images/mo-logo.png';
import { Outlet, Link, useLocation } from "react-router-dom";
import { Fade, IconButton, Backdrop, ThemeProvider, createTheme, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { purple } from '@mui/material/colors';


const theme = createTheme({
  typography: {
    fontFamily:  'SoraMedium' 
  },
  palette: {
    primary: {
      main: "#eb5424",
    },
  }
});

// const ColorButton = styled(Button)(({ theme }) => ({
//   color: theme.palette.getContrastText(purple[500]),
//   backgroundColor: '#eb5424',
//   '&:hover': {
//     backgroundColor: purple[700],
//   },
// }));


const Header = () => {

    const location = useLocation();

  return (
    <ThemeProvider theme={theme}>
      <div className='container-fluid bg-white sticky-top'>
        <nav class="navbar navbar-expand-lg justify-content-between navbar-light">
          <div className='d-flex'>
            <Link class="navbar-brand py-2 ms-2" to="/"><img src={moLogo} style={{height:'25px'}}/></Link>
            <div class="collapse navbar-collapse d-lg-block d-none" id="navbarTogglerDemo02">
              <ul class="navbar-nav ms-lg-3 mb-2 mb-lg-0">
              <li class="nav-item ms-3">
              <Link className={location.pathname.indexOf("/testimonials") == -1  ? 'nav-link active-menu fw-semibold':'nav-link'} to="/demo">Demo</Link>
              </li>
              <li class="nav-item ms-3">
              <Link className={location.pathname.indexOf("/testimonials") > -1 ? 'nav-link active-menu':'nav-link'} to="/testimonials">Customer Success</Link>
              </li>
              </ul>
            </div>
          </div>

          <div className='d-flex'>
            <button class="navbar-toggler me-1" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>
            <Button variant="contained" className='text-capitalize shadow-none' href='https://www.miniorange.com/#request_demo' target='_blank'>Book a demo</Button>
            <Button variant="outlined" className='ms-3 text-capitalize' href='https://www.miniorange.com/' target='_blank'>Visit site</Button>
          </div>
        </nav>

        <div class="collapse navbar-collapse" id="navbarTogglerDemo02">
          <ul class="navbar-nav ms-lg-3 mb-2 mb-lg-0 d-lg-none">
          <li class="nav-item ms-3">
            <div >
              <Link className={location.pathname.indexOf("/testimonials") == -1  ? 'nav-link active-menu fw-semibold w-25':'nav-link'} style={{width:'fitContent'}} to="/demo">Demo</Link>
            </div>
          </li>
          <li class="nav-item ms-3">
            <Link className={location.pathname.indexOf("/testimonials") > -1 ? 'nav-link active-menu fw-semibold w-25':'nav-link'} to="/testimonials">Customer Success</Link>
          </li>
          </ul>
        </div>
      </div>
      <Outlet />
    </ThemeProvider>
  )
}

export default Header